import { ResultListModel } from '@common-lib';

import { baseClient } from '../common';
import { SearchStampCardModel } from './search-stamp-card.model';
import { StampCardListModel } from './stamp-card-list.model';

const apiUrl = `/api/stamp-cards`;

export const stampCardClient = {
  list: (
    model: SearchStampCardModel,
  ): Promise<ResultListModel<StampCardListModel>> => {
    return baseClient.body<
      SearchStampCardModel,
      ResultListModel<StampCardListModel>
    >({
      body: model,
      method: 'POST',
      url: `${apiUrl}/list`,
    });
  },
};
